import { defineAsyncComponent } from 'vue'
export default {
  "carrier-profile": defineAsyncComponent(() => import("/app/layouts/carrier-profile.vue")),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue"))
}